import pclnData from './pcln-data'
import { copy, traverse, determine } from './object'
import { dotpath, uniqueString } from './string'
import { isBrowser, isLocalStorageEnabled } from './environment'

const _state = uniqueString('Storage_state')

const STORAGE_KEY = `[STATE] > ${pclnData().appName}`

class Storage {
  constructor() {
    this[_state] = null
  }

  get state() {
    if (!isBrowser() || !isLocalStorageEnabled()) return {}
    if (!this[_state]) {
      const stored = localStorage.getItem(STORAGE_KEY)
      const is = determine(stored)

      if (!is.object) {
        this[_state] = {}
      } else {
        this[_state] = JSON.parse(stored) || {}
      }
    }

    return copy(this[_state])
  }

  get(key) {
    return copy(traverse(this[_state], key))
  }

  save(key, value) {
    if (!key) return

    const state = this.state
    const parts = key.split(/\./)

    if (parts.length > 1) {
      const parentParts = parts.slice(0, parts.length - 1)
      const parentPath = dotpath(...parentParts)
      const finalKey = parts[parts.length - 1]
      let parent = traverse(state, parentPath)

      if (!determine(parent).object) {
        let current = state

        for (const part of parentParts) {
          if (!determine(current[part]).object) {
            current = current[part] = {}
          } else {
            current = current[part]
          }
        }

        parent = current
      }

      parent[finalKey] = value
    } else {
      state[key] = value
    }

    this[_state] = state

    if (isBrowser() && isLocalStorageEnabled()) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    }
  }
}

const INSTANCE = new Storage()
export default INSTANCE
